export default "__VITE_ASSET__RraqK48I__"